<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách nhóm người dùng</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          type="button"
          class="font-medium f12 btn btn-outline-secondary"
          @click="$router.push('/customer-support/group-user/create')"
        >
          Thêm mới
        </button>
      </div>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="">
          <div class="form-group">
            <input
              v-model.trim="search.teamName"
              type="text"
              placeholder="Từ Khóa"
              style="border-radius: 4px"
              @keyup.enter.prevent="fetchData"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.statusTeam"
              :options="Config.getSearch(optionStatus)"
              placeholder="Trạng thái"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="dateRange"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 11.5em; margin-left: -5px !important"
                  class="text-center"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>

          <div class="form-group form-group-action">
            <button
              type="button"
              @click="fetchData()"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="clearSearch()"
            >
              <i class="bx bx-filter-alt"></i>
              <span class="ml-1"></span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(code)="data">
                <p>{{ data.item.code ?? '' }}</p>
              </template>
              <template #cell(name)="data">
                <p>{{ data.item.name ?? '' }}</p>
              </template>
              <template #cell(time)="data">
                <p>
                  Ngày tạo:
                  <span>{{ data.item.createdDate | formatDate('HH:mm, DD/MM/YYYY') }}</span>
                </p>
                <p>
                  Ngày cập nhật:
                  <span>{{ data.item.lastModifiedDate | formatDate('HH:mm, DD/MM/YYYY') }}</span>
                </p>
              </template>
              <template #cell(status)="data">
                <span
                  class="badge"
                  :class="data.item.status ? getColor(data.item.status, optionColorStatus) : ''"
                  >{{ data.item.status ? joinArrayData(data.item.status, optionStatus) : '' }}</span
                >
              </template>
              <template #cell(actionBy)="data">
                <p>Người tạo: {{ data.item.createdBy ?? '' }}</p>
                <p>Người cập nhật: {{ data.item.lastModifiedBy ?? '' }}</p>
              </template>
              <template #cell(ownerGroup)="data">
                <div
                  v-html="formattedArray(data.item.groupOwner)"
                  v-if="data.item.groupOwner && data.item.groupOwner.length > 0"
                ></div>
              </template>

              <template #cell(action)="data">
                <div class="text-left m-b-5">
                  <b-link
                    :to="`/customer-support/group-user/${data.item.id}`"
                    style="color: #0056f6"
                    size="sm"
                  >
                    <img
                      src="@/assets/img/circle-three-dots.svg"
                      alt="Circle with Three Dots"
                      style="width: 15px; height: 15px"
                    />
                    Chi tiết
                  </b-link>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>

      <div class="pagination-bottom">
        <b-pagination
          v-model="search.page"
          @change="onChangePage"
          :total-rows="pagination.total"
          :per-page="search.limit"
          class="mr-2 fl-right"
        ></b-pagination>
      </div>
    </div>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>
<script>
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import { List } from '@/services/customer-support/group-user'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'code', label: 'Mã nhóm', thStyle: 'min-width: 150px', class: 'text-center' },
    { key: 'name', label: 'Tên nhóm', thStyle: 'min-width: 200px', class: 'text-center' },
    {
      key: 'time',
      label: 'Ngày tạo/Ngày cập nhật',
      thStyle: 'min-width: 300px',
      class: 'text-center',
    },
    {
      key: 'status',
      label: 'Trạng thái hoạt động',
      thStyle: 'min-width: 150px',
      class: 'text-center',
    },
    {
      key: 'actionBy',
      label: 'Người tạo/ Người cập nhật',
      thStyle: 'min-width: 300px',
      class: 'text-center',
    },
    {
      key: 'ownerGroup',
      label: 'Người sở hữu nhóm',
      thStyle: 'min-width: 300px',
      class: 'text-center',
    },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]

  export default {
    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        search: {
          page: 1,
          limit: 20,
        },
        showLoading: false,
        loading: false,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        optionStatus: [
          { id: 'OPEN', text: 'Đang hoạt động' },
          { id: 'CLOSE', text: 'Khóa' },
        ],
        optionColorStatus: {
          OPEN: 'success',
          CLOSE: 'danger',
        },
        lists: [],
        pagination: {
          total: 0,
        },
      }
    },
    created() {
      this.fetchData()
    },
    computed: {
      joinArrayData() {
        return (item, options) => {
          const mapData = options.find(e => e.id === item)
          return mapData ? mapData.text : ''
        }
      },
      getColor() {
        return (code, option) => {
          if (!code) return code
          return option[code] ? option[code] : code
        }
      },
      formattedArray() {
        return array => {
          return array.join('<br>')
        }
      },
    },
    methods: {
      async fetchData() {
        try {
          this.loading = true
          const bodySearch = {}
          for (const key in this.search) {
            if (this.search[key] && this.search[key] !== '0') {
              bodySearch[key] = this.search[key]
            }
          }

          if (this.dateRange.endDate) {
            bodySearch.createDateEnd = moment(this.dateRange.endDate)
              .endOf('day')
              .add(7, 'hours')
              .valueOf()
          }
          if (this.dateRange.startDate) {
            bodySearch.createDateStart = moment(this.dateRange.startDate)
              .startOf('day')
              .add(7, 'hours')
              .valueOf()
          }

          const response = await List(bodySearch)
          if (response.code === 1000) {
            this.lists = response.data ?? []
            this.pagination.total =
              response.meta && response.meta.pagination && response.meta.pagination.total
                ? response.meta.pagination.total
                : 0
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.loading = false
        }
      },
      clearSearch() {
        this.search = {
          page: 1,
          limit: 20,
        }
        ;(this.dateRange = {
          startDate: null,
          endDate: null,
        }),
          this.fetchData()
      },
      onChangePage(page) {
        this.search.page = page
        this.fetchData()
      },
    },
  }
</script>
<style scoped>
  .success {
    color: #fff;
    background-color: #28a745;
  }
  .danger {
    color: #fff;
    background-color: #dc3545;
  }
</style>
